import React, { useEffect, useState } from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from '@mui/material'
import ButtonInc from '../../../../../shared-ui/ButtonInc'

const COPY = {
  ReConfirm: {
    title: 'Re-confirm policy',
    body:
      'This sends the policy back through approval. The approval stages will be reopened.',
    reasonLabel: 'Reason (optional)',
    confirm: 'Re-Confirm',
    reasonRequired: false
  },
  Discard: {
    title: 'Discard policy',
    body:
      'This permanently discards the policy. It cannot be re-confirmed afterwards.',
    reasonLabel: 'Reason for discarding',
    confirm: 'Discard',
    reasonRequired: true
  }
}

const RejectedPolicyActionDialog = props => {
  const [reason, setReason] = useState('')

  useEffect(() => {
    if (props.action) setReason('')
  }, [props.action])

  const copy = COPY[props.action]
  if (!copy) return null

  const missingReason = copy.reasonRequired && !reason.trim()

  return (
    <Dialog
      open={!!props.action}
      onClose={props.onCancel}
      aria-labelledby="rejected-policy-action-title"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle id="rejected-policy-action-title">
        {copy.title} {props.policyNumber}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>Are you sure? {copy.body}</DialogContentText>
        <TextField
          label={copy.reasonLabel}
          value={reason}
          onChange={e => setReason(e.target.value)}
          required={copy.reasonRequired}
          multiline
          minRows={2}
          fullWidth
          margin="normal"
          inputProps={{ 'data-testid': 'rejected-policy-reason' }}
        />
      </DialogContent>
      <DialogActions>
        <ButtonInc btnType="secondary" onClick={props.onCancel} autoFocus>
          Cancel
        </ButtonInc>
        <ButtonInc
          onClick={() => props.onConfirm(reason.trim())}
          disabled={missingReason}
          style={props.action === 'Discard' ? { background: '#8F191C' } : {}}
        >
          {copy.confirm}
        </ButtonInc>
      </DialogActions>
    </Dialog>
  )
}

export default RejectedPolicyActionDialog
